/**
 * YmTreeFallingIllustration/index.js
 * desc: YM tree with falling leaves animation
 * note: stateless presentational component
 */
'use strict';

import { YmIconOutline } from '../../../components/Brand';
import { ManWalkingIllustration } from '../../../components/Illustration';
import { classNames } from '../../../utilities';
import './styles.css';

const YmTreeFallingIllustration = ({ className }) => {
    const classList = classNames('tree-with-falling-leaves illustration', className);

    return (
        <figure className={ classList }>
            <figure className="circle center"></figure>
            <figure className="circle left"></figure>
            <figure className="circle right"></figure>
            <YmIconOutline/>
            <ManWalkingIllustration />
        </figure>
    );
};



export default YmTreeFallingIllustration;
